import React from "react";

//Components
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
} from "@mui/material/styles";
import { Alert, Snackbar } from "@mui/material";

const CustomizedSnackbars = (props) => {
  const getMuiTheme = () =>
    createTheme({
      components: {
        MuiSnackbar: {
          styleOverrides: {
            anchorOriginTopRight: {
              marginTop: "50px",
            },
          },
        },
      },
    });

  return (
    <MuiThemeProvider theme={getMuiTheme()}>
      <Snackbar
        autoHideDuration={props.hide ? props.hide : 5000}
        open={props.open}
        onClose={props.handleClose}
        anchorOrigin={props.anchorOrigin}
      >
        <Alert
          elevation={3}
          variant="filled"
          onClose={props.handleClose}
          severity={props.variant}
        >
          {props.message}
        </Alert>
      </Snackbar>
    </MuiThemeProvider>
  );
};

export default CustomizedSnackbars;
